var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 1.00781L15.2663 3.0685L17.3269 4.16754L15.2663 5.26657L14.1673 7.32726L13.0682 5.26657L11.0075 4.16754L13.0682 3.0685L14.1673 1.00781ZM6.66721 3.61198L8.88942 7.77865L13.0561 10.0009L8.88942 12.2231L6.66721 16.3898L4.44498 12.2231L0.27832 10.0009L4.44498 7.77865L6.66721 3.61198ZM16.3894 13.612L15.0006 11.0079L13.6117 13.612L11.0075 15.0009L13.6117 16.3898L15.0006 18.9939L16.3894 16.3898L18.9936 15.0009L16.3894 13.612Z",
    fill: "#86949D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.d0453ff2e9df10d203c2605f3e3d4880.svg";
export { ForwardRef as ReactComponent };